import * as Moment from "moment";
const toTeaserProps = (p)=>({
        headingLevel: 'h2',
        title: p.Title,
        intro: p.Description,
        label: Moment(p.PublicationDate).format('LL'),
        imageAlt: p.ImageAlt,
        imageUrl: p.ImageUrls['420x320'],
        imageUrlFallback: p.ImageUrls['4x3'],
        imageUrlLarge: p.ImageUrls['840x640'],
        linkUrl: p.Url,
        key: `news_item_${p.EntityId}`
    });
export const getNews = (page, pageSize)=>async ()=>{
        let headers = new Headers();
        headers.append('X-XSRF-TOKEN', document.getElementsByName("__RequestVerificationToken")[0].value);
        const response = await fetch(`/api/v1/search/list?type=news&page=${page}&pageSize=${pageSize}`, {
            headers
        });
        if (response.ok) {
            const body = await response.json();
            return {
                kind: "result",
                value: {
                    totalResults: body.Count,
                    news: body.Results.map(toTeaserProps)
                },
                status: response.status
            };
        }
        return {
            kind: "failed",
            status: response.status
        };
    };
